import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { usersApi } from '../../../services/users';
import { useLocation } from "react-router-dom";
import { analyticsApi } from '../../../services/analytics';

const ResetPassword = () => {
  const [password, setPassword] = useState<string>('');
  const [passwordError, setPasswordError] = useState<string>('');

  const location  = useLocation();

  useEffect(() => {
    analyticsApi.logEvent(
      '',
      'View',
      {},
      'ResetPassword'
    );
  }, []);

  const resetPassword = async () => {
    try {
      const params = new URLSearchParams(location.search)
      let token = params.get('token')
      const response = await usersApi.resetPassword(token, password);
      if(!response.data.error) {
        window.location.href = '/signin'
        setPasswordError('')
      } else {
        setPasswordError(response.data.message)
      }
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <>
      <div className={styles.body}>
        <div className={'w100'}>
          <h1 className={`scene_title`}>Set Password</h1>
        </div>
        <div className={'w100'}>
          <Input
            hasError={!!passwordError}
            errorMessage={passwordError}
            value={password}
            onChange={setPassword}
            type={'password'}
            placeholder={'Enter password'}
            label={'Password'}
          />
        </div>
        <Button type={'default'} onClick={resetPassword}>
          Continue
        </Button>
      </div>
      <div className={styles.footer}>
        By continuing you agree to our <br />
        <a href="https://myorganicapps.com/en/terms.html" target="_blank">
          Terms of Service
        </a>{' '}
        |{' '}
        <a href="https://myorganicapps.com/en/privacy.html" target="_blank">
          Privacy Policy
        </a>{' '}
        |{' '}
        <a
          href="https://myorganicapps.com/en/money-back-policy.html"
          target="_blank"
        >
          Money Back Policy
        </a>{' '}
        <br />
        2021. All rights reserved.
      </div>
    </>
  );
};

export default ResetPassword;
